import $, { error } from "jquery";

const language = $(document.documentElement).prop("lang");

const $aiCorrectionContainer = $("#ai-correction-container");
if ($aiCorrectionContainer.length) {
    const questionId = $aiCorrectionContainer.data("questionId");
    $.ajax({
        url: `/${language}/ai-correction/${questionId}`,
        success: function (response) {
            $aiCorrectionContainer.html(response);
        },
        error: function (errorResponse) {
            $aiCorrectionContainer.html(errorResponse);
        }
    });
}
